<template>
    <div class="mediateBox">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <!--            我的案件-->
            <el-tab-pane label="我的案件" name="first">
                <myMediation v-if="activeName === 'first'"></myMediation>
            </el-tab-pane>
            <!--            被调解案件-->
            <el-tab-pane label="被调解案件" name="second">
                <beMediated v-if="activeName === 'second'"></beMediated>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import myMediation from './components/myMediation';
    import beMediated from './components/beMediated';

    export default {
        name: 'mediate',
        data() {
            return {
                activeName: 'first'
            };
        },
        components: {
            myMediation,
            beMediated
        },
        methods: {
            updateType () {
                let type = this.$route.query.type
                // 判断type的值，更改activeName的值
                //我申请的仲裁案件
                if (type === 'first') {
                    sessionStorage.setItem('mediateCase', 'first')
                    return this.activeName = 'first'
                    //    我发起的
                }else if (type === 'second') {
                    sessionStorage.setItem('mediateCase', 'second')
                    return this.activeName = 'second'
                }
            },
            handleClick(tab, event) {
                sessionStorage.setItem('mediateCase', tab.name);
            }
        },
        created() {
            this.updateType()
            let name = sessionStorage.getItem('mediateCase');
            // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
            if (name) {
                this.activeName = name;
            }
        }
    };
</script>

<style scoped>
    .mediateBox {
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
    }

    /deep/ .el-tabs__nav-wrap::after {
        background-color: transparent;
    }

    /deep/ .el-tabs__item {
        padding: 0px 30px;
    }
</style>
